const TASKS_POLL_PATH = /\/api\/flow\/[^/?#]+\/tasks(?:[?#]|$)/;

export interface NetworkRequestRef {
	method?: string;
	statusCode?: number;
	url?: string;
}

export const isTasksPollUrl = (url: string | undefined): boolean =>
	!!url && TASKS_POLL_PATH.test(url);

/** Status 0 on the waiting-screen poll: no response, and the poller retries. */
export const isRetryableTasksPollNetworkError = ({
	method,
	statusCode,
	url,
}: NetworkRequestRef): boolean =>
	method === "GET" && statusCode === 0 && isTasksPollUrl(url);

export const shouldForwardBrowserLog = (event: {
	origin?: string;
	http?: { method?: string; status_code?: number; url?: string };
}): boolean => {
	if (event.origin !== "network") return true;
	return !isRetryableTasksPollNetworkError({
		method: event.http?.method,
		statusCode: event.http?.status_code,
		url: event.http?.url,
	});
};

export const shouldForwardRumEvent = (event: {
	type: string;
	error?: {
		source?: string;
		resource?: { method?: string; status_code?: number; url?: string };
	};
}): boolean => {
	if (event.type !== "error" || event.error?.source !== "network") {
		return true;
	}
	return !isRetryableTasksPollNetworkError({
		method: event.error.resource?.method,
		statusCode: event.error.resource?.status_code,
		url: event.error.resource?.url,
	});
};
